<template>
	<ModalFormCard :action="action" class="modal-default" :submittedCallback="callback">
		<template #title>{{ showCreate ? 'Create user' : 'Edit user' }}</template>

		<template #default="{ saving, errors }">

			<!-- <div class='flex items-center justify-center w-full py-6'>
				<div class='w-[100px] h-[100px] bg-grey-300 rounded-tl-[50px] rounded-br-[50px] flex items-center justify-center shrink-0 overflow-hidden'>
                    <IconUser class="w-12 h-12 stroke-grey-800" v-if='user.profile_image == null' />
                    <img :src="user.profile_image" class="w-full h-full object-cover" v-else />
                </div>
			</div> -->

			<div class="grid gap-2 grid-cols-2" v-if='showUser || showCreate || showAdminEdit'>
				<Input
					v-model:value="value.first_name"
					groupClass="bg-grey text-15"
					label="First name"
					name="first_name"
					placeholder="Enter first name"
				/>

				<Input
					v-model:value="value.last_name"
					groupClass="bg-grey text-15"
					label="Last name"
					name="last_name"
					placeholder="Enter last name"
				/>
			</div>

			<InputFile label='Profile image' class='mt-4' v-if='showUser && !showAdminEdit' name='profile_image' />

			<Input
				v-if='showContact || showCreate || showAdminEdit'
				v-model:value="value.email"
				class="mt-4"
				groupClass="!bg-grey text-15"
				label="Email address"
				name="email"
				placeholder="Email address"
				autocomplete="new-email"
			/>

			<Input
				v-if='showContact || showCreate'
				v-model:value="value.contact_number_1"
				class="mt-4"
				groupClass="bg-grey text-15"
				label="Phone number"
                name="contact_number_1"
                placeholder="Phone number"
			/>

			<Input
				v-model:value="value.password"
				:type="canSeePassword ? 'text' : 'password'"
				groupClass="!bg-grey text-15"
				label="New password"
				name="password"
				placeholder="Enter new password"
				class='mt-4'
				v-if='showCreate || showAdminEdit'
				autocomplete="new-password"
			>
				<template #right>
					<button
						class="w-10 h-10 flex items-center justify-center"
						type="button"
						@click="canSeePassword = !canSeePassword"
					>
						<IconRead
							v-if="!canSeePassword"
							class="h-auto w-6 stroke-black"
						/>
						<IconClose
							v-else
							class="h-4.5 w-4.5 stroke-black"
						/>
					</button>
				</template>
			</Input>

			<template v-if='showAddress'>
				<Input
					v-model:value="value.address_line_1"
					class="mt-4"
					groupClass="bg-grey text-15"
					label="Address"
					name="address_line_1"
					placeholder="Line 1"
				/>
				<Input
					v-model:value="value.address_line_2"
					class="mt-1"
					groupClass="bg-grey text-15"
					name="address_line_2"
					placeholder="Line 2"
				/>
				<Input v-model:value="value.town" class="mt-1" groupClass="bg-grey text-15" name="town" placeholder="City / town" />
				<Input
					v-model:value="value.postcode"
					class="mt-1"
					groupClass="bg-grey text-15"
					name="postcode"
					placeholder="Post code"
				/>
			</template>

			<Select
				v-model:value="value.role_id"
				:disabled="this.editingModel ? this.editingModel.hasRole('customer.owner') : false"
				:options="
					roles.map((r) => {
						return {
							html: $help.capitalizeFirstLetter(
								r.name.replace('customer.', ''),
							),
							value: r.id,
						};
					})
				"
				class="mt-4 hidden"
				label="Role"
				menuClass="!bg-grey"
				name="role_id"
				placeholder="Select role"
				selectClass="!bg-grey text-15"
			/>

			<div class="modal-buttons pt-6">
				<ButtonSaving :disabled="saving" class="default button-black h-12 px-6">
					{{ showCreate ? 'Create user' : 'Update user' }}
				</ButtonSaving>

				<button
					class="default button-black-outline h-12 px-6"
					type="button"
					@click="generatePassword"
				>
					Generate password
				</button>
			</div>
		</template>
	</ModalFormCard>
</template>

<script>
import User from "~/models/user.js";
import Modal from "~/mixins/modal.js";
import InputFile from "~/components/customer/input/file.vue";

export default {
	mixins: [Modal],

	created() {
		this.getRoles();

		this.setup(User, this.editingModel);
		console.log(this.value)
		this.value.full = 1;
		this.value.show = this.options.show
		this.value.contact_number_1 = this.$help.e164ToNumber(this.value.contact_number_1, false, false)

		if (this.showCreate) {
			this.value.password = this.$help.generatePassword();
			this.canSeePassword = true;
		}
	},

	data() {
		return {
			roles: [],
			canSeePassword: false
		};
	},

	methods: {
		getRoles() {
			return this.$axios.get("/roles?role=customer").then((res) => {
				this.roles = res;
			});
		},

		callback() {
			this.$authSanctum.getUser(true)
			this.$event.$emit('modal-form-completed')
            this.$event.$emit('modal-close')
		},

		generatePassword() {
			this.value.password = this.$help.generatePassword();
			this.canSeePassword = true;
		},
	},

	computed: {
		showUser() {
			return this.options.show == 'user'
		},

		showContact() {
			return this.options.show == 'contact'
		},

		showAddress() {
			return this.options.show == 'address'
		},

		showCreate() {
			return this.options.show == 'create'
		},

		showAdminEdit() {
			return this.options.show == 'adminEdit'
		}
	},

	components: {
		InputFile,
	},
};
</script>
